// @ts-check
import { forEach, keyBy } from "lodash";

import { PLANNER_REQUESTED } from "../../columnTypes";
import newColumn from "../util/newColumn";
import {
  buildGroupingLookup,
  hashGrouping,
  setCalculatedSumTotals,
  setNotifications,
  buildGroupLookup,
} from "../util";

import buildGroupings from "./buildGroupings/byDemand";

/**
 * @deprecated I think this is no longer used, but keeping it for now
 */
const buildPlannerLineOfBusiness = ({
  rootGroup,
  data,
  hideHiddenTeams,
  showObjectives,
  groupTypes,
  shouldHash,
}) => {
  const groupLookup = buildGroupLookup({
    macroAllocationGroups: data.macroAllocationGroups,
    descendantSupplyGroups: data.descendantSupplyGroups,
    roleAreaGroups: data.roleAreaGroups,
    relatedSupplyGroups: data.relatedSupplyGroups,
    descendantTargetGroups: data.descendantTargetGroups,
    relatedBudgetTargetGroups: data.relatedBudgetTargetGroups,
    groupTypes,
  });

  const allocationProjectLookup = keyBy(data.allocationProjects, "id");
  // we need a column so we have a place to put the notification.
  const columns = [newColumn({ columnType: PLANNER_REQUESTED })];

  const groupings = buildGroupings({
    rootGroup,
    groupLookup,
    hideHiddenTeams,
    showObjectives,
    groupTypes,
    columnCount: columns.length,
    isBudgetEnabled: false, // Budget is not enabled in the planner
    allocationProjectLookup,
  });
  setCalculatedSumTotals(groupings, columns);
  setNotifications(groupings, columns);

  const columnLookup = keyBy(columns, "id");
  const groupingLookup = buildGroupingLookup(groupings, {});
  const isPendingSubmit = false;

  // Hash groupings in case anything changed
  if (shouldHash) {
    forEach(groupings, hashGrouping);
  }

  return {
    isPendingSubmit,
    columns,
    groupings,
    // lookup objects: for when we need fast access to objects in the tree
    lookups: {
      columnLookup,
      groupingLookup,
    },
  };
};

export default buildPlannerLineOfBusiness;
